import { v4 as uuid } from "uuid";
import { useSetRecoilState } from "recoil";
import { toastState } from "../features/recoil";

type ShowToastArgs = {
    id?: string;
    content?: string;
    type?: "success" | "info" | "error" | "warning";
    onConfirm?: Function;
    onCancel?: Function;
    uniqueId?: string | null;
};

type UseToastReturn = {
    showToast: (args: ShowToastArgs) => void;
    hideToast: () => void;
};

export const useToast = (): UseToastReturn => {
    const setToast = useSetRecoilState(toastState);

    const showToast = (args: ShowToastArgs) => {
        const { id, content, type, onConfirm, onCancel, uniqueId = null } = args || {};

        setToast((prev) => {
            const filtered = prev.filter((item) => {
                return item.uniqueId === null || item.uniqueId !== uniqueId;
            });

            return [
                ...filtered,
                {
                    id: uuid(),
                    isOpen: true,
                    content,
                    type,
                    onConfirm,
                    onCancel,
                    uniqueId,
                },
            ];
        });
    };

    const hideToast = () => {
        setToast([]);
    };

    return { showToast, hideToast };
};
